import ANDGateVertex from './ANDGateNode/ANDGateVertex';
import NANDGateVertex from './NANDGateNode/NANDGateVertex';
import ORGateVertex from './ORGateNode/ORGateVertex';
import NORGateVertex from './NORGateNode/NORGateVertex';
import XORGateVertex from './XORGateNode/XORGateVertex';
import NOTGateVertex from './NOTGateNode/NOTGateVertex';
import IFFGateVertex from './IFFGateNode/IFFGateVertex';

import IMPLYGateVertex from './IMPLYGateNode/IMPLYGateVertex';
import ATLEASTGateVertex from './ATLEASTGateNode/ATLEASTGateVertex';
import CARDINALITYGateVertex from './CARDINALITYGateNode/CARDINALITYGateVertex';
import GateVertexValue, {GateVertexValueJSON} from './GateVertexValue';
import Formula, {FormulaJSON} from "../../HCLTreeVertexValue/Formula";
import ProxyTypes from "../../HCLTreeVertexValue/ProxyTypes";
import GateTypes from "../../HCLTreeVertexValue/GateTypes";
import Label from "../../HCLTreeVertexValue/Label";
import ORGateVertexValue from "./ORGateNode/ORGateVertexValue";
import ANDGateVertexValue from "./ANDGateNode/ANDGateVertexValue";
import NOTGateVertexValue from "./NOTGateNode/NOTGateVertexValue";
import IFFGateVertexValue from "./IFFGateNode/IFFGateVertexValue";
import NORGateVertexValue from "./NORGateNode/NORGateVertexValue";
import XORGateVertexValue from "./XORGateNode/XORGateVertexValue";
import NANDGateVertexValue from "./NANDGateNode/NANDGateVertexValue";
import IMPLYGateVertexValue from "./IMPLYGateNode/IMPLYGateVertexValue";
import ATLEASTGateVertexValue from "./ATLEASTGateNode/ATLEASTGateVertexValue";
import CARDINALITYGateVertexValue from "./CARDINALITYGateNode/CARDINALITYGateVertexValue";


class GateVertexBuilder {

  static build(key: string, json: GateVertexValueJSON) {

    const formulaJSON = json.formula as FormulaJSON;

    if (formulaJSON._proxy !== ProxyTypes.LOGICAL_EXPRESSION) throw new Error(`Cannot resolve proxy ${formulaJSON._proxy}`);

    let label = new Label(key); // legacy support
    if (json.label && Object.keys(json.label).length) label = Label.build(json.label);

    const formula = new Formula(formulaJSON);

    switch (formulaJSON.expr) {
      case GateTypes.OR:          return new ORGateVertex(key, new ORGateVertexValue(label, formula));
      case GateTypes.AND:         return new ANDGateVertex(key, new ANDGateVertexValue(label, formula));
      case GateTypes.NOT:         return new NOTGateVertex(key, new NOTGateVertexValue(label, formula));
      case GateTypes.IFF:         return new IFFGateVertex(key, new IFFGateVertexValue(label, formula));
      case GateTypes.NOR:         return new NORGateVertex(key, new NORGateVertexValue(label, formula));
      case GateTypes.XOR:         return new XORGateVertex(key, new XORGateVertexValue(label, formula));
      case GateTypes.NAND:        return new NANDGateVertex(key, new NANDGateVertexValue(label, formula));
      case GateTypes.IMPLY:       return new IMPLYGateVertex(key, new IMPLYGateVertexValue(label, formula));
      case GateTypes.AT_LEAST:    return new ATLEASTGateVertex(key, new ATLEASTGateVertexValue(label, formula));
      case GateTypes.CARDINALITY: return new CARDINALITYGateVertex(key, new CARDINALITYGateVertexValue(label, formula));
      default:
        throw new Error(`Cannot resolve gate type ${formulaJSON.expr}`);
    }

  }

}

export default GateVertexBuilder;
